// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-37a7a53e] {\n  text-transform: uppercase;\n}\n.disabled[data-v-37a7a53e] {\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
